// @generated by protobuf-ts 2.11.1 with parameter long_type_number,generate_dependencies
// @generated from protobuf file "shared/domains/vlp-billing/vlp-billing-history-topup-request-response.proto" (package "vlp.billing", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { BasePageQueryMsg } from "../../../domains/vlp-billing/vlp-billing-common";
import { CurrencyExchangeDTO } from "../../../domains/vlp-billing/vlp-billing-history-model";
import { TopupOrderDTO } from "../../../domains/vlp-billing/vlp-billing-history-model";
import { ActionResponse } from "../../../common";
/**
 * @generated from protobuf message vlp.billing.TopupOrderResponse
 */
export interface TopupOrderResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: vlp.billing.TopupOrderDTO data = 2
     */
    data?: TopupOrderDTO;
}
/**
 * @generated from protobuf message vlp.billing.TopupOrderListResponse
 */
export interface TopupOrderListResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: repeated vlp.billing.TopupOrderDTO items = 2
     */
    items: TopupOrderDTO[];
}
/**
 * @generated from protobuf message vlp.billing.CurrencyExchangeListResponse
 */
export interface CurrencyExchangeListResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: repeated vlp.billing.CurrencyExchangeDTO items = 2
     */
    items: CurrencyExchangeDTO[];
}
/**
 * â”€â”€ Invoice export (MISA): preview/history JSON blob; file Excel/PDF giá»¯ REST â”€â”€
 *
 * @generated from protobuf message vlp.billing.InvoicePreviewRequest
 */
export interface InvoicePreviewRequest {
    /**
     * @generated from protobuf field: string payload_json = 1
     */
    payloadJson: string;
}
/**
 * @generated from protobuf message vlp.billing.InvoicePreviewResponse
 */
export interface InvoicePreviewResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: string data_json = 2
     */
    dataJson: string;
}
/**
 * @generated from protobuf message vlp.billing.InvoiceHistoryRequest
 */
export interface InvoiceHistoryRequest {
    /**
     * @generated from protobuf field: string from_date = 1
     */
    fromDate: string;
    /**
     * @generated from protobuf field: string to_date = 2
     */
    toDate: string;
    /**
     * @generated from protobuf field: repeated int64 account_group_ids = 3
     */
    accountGroupIds: number[];
}
/**
 * @generated from protobuf message vlp.billing.InvoiceHistoryResponse
 */
export interface InvoiceHistoryResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: string data_json = 2
     */
    dataJson: string;
}
/**
 * @generated from protobuf message vlp.billing.ShipmentSalePriceRequest
 */
export interface ShipmentSalePriceRequest {
    /**
     * @generated from protobuf field: int64 shipment_info_id = 1
     */
    shipmentInfoId: number;
    /**
     * @generated from protobuf field: string reference_id = 2
     */
    referenceId: string;
}
/**
 * @generated from protobuf message vlp.billing.ShipmentSalePriceResponse
 */
export interface ShipmentSalePriceResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: string data_json = 2
     */
    dataJson: string;
}
/**
 * @generated from protobuf message vlp.billing.CreateTopupOrderRequest
 */
export interface CreateTopupOrderRequest {
    /**
     * @generated from protobuf field: int64 wallet_info_id = 1
     */
    walletInfoId: number;
    /**
     * @generated from protobuf field: string provider_code = 2
     */
    providerCode: string;
    /**
     * @generated from protobuf field: string requested_amount = 3
     */
    requestedAmount: string;
    /**
     * @generated from protobuf field: string currency_code = 4
     */
    currencyCode: string;
    /**
     * @generated from protobuf field: string transaction_ref = 5
     */
    transactionRef: string;
    /**
     * @generated from protobuf field: string evidence_url = 6
     */
    evidenceUrl: string;
    /**
     * @generated from protobuf field: string user_note = 7
     */
    userNote: string;
    /**
     * @generated from protobuf field: string idempotency_key = 8
     */
    idempotencyKey: string;
}
/**
 * @generated from protobuf message vlp.billing.TopupOrderIdRequest
 */
export interface TopupOrderIdRequest {
    /**
     * @generated from protobuf field: int64 topup_order_id = 1
     */
    topupOrderId: number;
}
/**
 * @generated from protobuf message vlp.billing.CancelTopupOrderRequest
 */
export interface CancelTopupOrderRequest {
    /**
     * @generated from protobuf field: int64 topup_order_id = 1
     */
    topupOrderId: number;
    /**
     * @generated from protobuf field: string reason = 2
     */
    reason: string;
}
/**
 * @generated from protobuf message vlp.billing.ApproveTopupOrderRequest
 */
export interface ApproveTopupOrderRequest {
    /**
     * @generated from protobuf field: int64 topup_order_id = 1
     */
    topupOrderId: number;
    /**
     * @generated from protobuf field: string admin_note = 2
     */
    adminNote: string;
}
/**
 * @generated from protobuf message vlp.billing.RejectTopupOrderRequest
 */
export interface RejectTopupOrderRequest {
    /**
     * @generated from protobuf field: int64 topup_order_id = 1
     */
    topupOrderId: number;
    /**
     * @generated from protobuf field: string reject_reason = 2
     */
    rejectReason: string;
}
/**
 * @generated from protobuf message vlp.billing.RefundTopupRequest
 */
export interface RefundTopupRequest {
    /**
     * @generated from protobuf field: int64 topup_order_id = 1
     */
    topupOrderId: number;
    /**
     * @generated from protobuf field: string amount = 2
     */
    amount: string;
    /**
     * @generated from protobuf field: string reason = 3
     */
    reason: string;
}
/**
 * @generated from protobuf message vlp.billing.GetTopupOrdersForReviewRequest
 */
export interface GetTopupOrdersForReviewRequest {
    /**
     * @generated from protobuf field: string status = 1
     */
    status: string;
    /**
     * @generated from protobuf field: string provider_code = 2
     */
    providerCode: string;
    /**
     * @generated from protobuf field: string from_date = 3
     */
    fromDate: string;
    /**
     * @generated from protobuf field: string to_date = 4
     */
    toDate: string;
    /**
     * @generated from protobuf field: string currency_code = 5
     */
    currencyCode: string;
    /**
     * @generated from protobuf field: string min_amount = 6
     */
    minAmount: string;
    /**
     * @generated from protobuf field: string max_amount = 7
     */
    maxAmount: string;
    /**
     * @generated from protobuf field: string keyword = 8
     */
    keyword: string;
    /**
     * @generated from protobuf field: vlp.billing.BasePageQueryMsg page_query = 9
     */
    pageQuery?: BasePageQueryMsg;
    /**
     * @generated from protobuf field: bool attention_only = 10
     */
    attentionOnly: boolean;
}
/**
 * @generated from protobuf message vlp.billing.TopupOrderPagedResponse
 */
export interface TopupOrderPagedResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: int32 total_records = 2
     */
    totalRecords: number;
    /**
     * @generated from protobuf field: repeated vlp.billing.TopupOrderDTO items = 3
     */
    items: TopupOrderDTO[];
    /**
     * @generated from protobuf field: bool attention_enabled = 4
     */
    attentionEnabled: boolean;
    /**
     * @generated from protobuf field: bool sound_enabled = 5
     */
    soundEnabled: boolean;
    /**
     * @generated from protobuf field: bool icon_enabled = 6
     */
    iconEnabled: boolean;
    /**
     * @generated from protobuf field: int32 ring_count = 7
     */
    ringCount: number;
    /**
     * @generated from protobuf field: int32 reminder_minutes = 8
     */
    reminderMinutes: number;
    /**
     * @generated from protobuf field: int32 escalation_minutes = 9
     */
    escalationMinutes: number;
    /**
     * @generated from protobuf field: int32 overdue_count = 10
     */
    overdueCount: number;
    /**
     * @generated from protobuf field: string attention_scope = 11
     */
    attentionScope: string;
    /**
     * @generated from protobuf field: string reminder_key = 12
     */
    reminderKey: string;
    /**
     * @generated from protobuf field: bool popup_on_new = 13
     */
    popupOnNew: boolean;
    /**
     * @generated from protobuf field: bool popup_on_login = 14
     */
    popupOnLogin: boolean;
}
// @generated message type with reflection information, may provide speed optimized methods
class TopupOrderResponse$Type extends MessageType<TopupOrderResponse> {
    constructor() {
        super("vlp.billing.TopupOrderResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "data", kind: "message", T: () => TopupOrderDTO }
        ]);
    }
    create(value?: PartialMessage<TopupOrderResponse>): TopupOrderResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TopupOrderResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TopupOrderResponse): TopupOrderResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* vlp.billing.TopupOrderDTO data */ 2:
                    message.data = TopupOrderDTO.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TopupOrderResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* vlp.billing.TopupOrderDTO data = 2; */
        if (message.data)
            TopupOrderDTO.internalBinaryWrite(message.data, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.TopupOrderResponse
 */
export const TopupOrderResponse = new TopupOrderResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TopupOrderListResponse$Type extends MessageType<TopupOrderListResponse> {
    constructor() {
        super("vlp.billing.TopupOrderListResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TopupOrderDTO }
        ]);
    }
    create(value?: PartialMessage<TopupOrderListResponse>): TopupOrderListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<TopupOrderListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TopupOrderListResponse): TopupOrderListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* repeated vlp.billing.TopupOrderDTO items */ 2:
                    message.items.push(TopupOrderDTO.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TopupOrderListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated vlp.billing.TopupOrderDTO items = 2; */
        for (let i = 0; i < message.items.length; i++)
            TopupOrderDTO.internalBinaryWrite(message.items[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.TopupOrderListResponse
 */
export const TopupOrderListResponse = new TopupOrderListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CurrencyExchangeListResponse$Type extends MessageType<CurrencyExchangeListResponse> {
    constructor() {
        super("vlp.billing.CurrencyExchangeListResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CurrencyExchangeDTO }
        ]);
    }
    create(value?: PartialMessage<CurrencyExchangeListResponse>): CurrencyExchangeListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<CurrencyExchangeListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CurrencyExchangeListResponse): CurrencyExchangeListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* repeated vlp.billing.CurrencyExchangeDTO items */ 2:
                    message.items.push(CurrencyExchangeDTO.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CurrencyExchangeListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated vlp.billing.CurrencyExchangeDTO items = 2; */
        for (let i = 0; i < message.items.length; i++)
            CurrencyExchangeDTO.internalBinaryWrite(message.items[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.CurrencyExchangeListResponse
 */
export const CurrencyExchangeListResponse = new CurrencyExchangeListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoicePreviewRequest$Type extends MessageType<InvoicePreviewRequest> {
    constructor() {
        super("vlp.billing.InvoicePreviewRequest", [
            { no: 1, name: "payload_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<InvoicePreviewRequest>): InvoicePreviewRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.payloadJson = "";
        if (value !== undefined)
            reflectionMergePartial<InvoicePreviewRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InvoicePreviewRequest): InvoicePreviewRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string payload_json */ 1:
                    message.payloadJson = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InvoicePreviewRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string payload_json = 1; */
        if (message.payloadJson !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.payloadJson);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.InvoicePreviewRequest
 */
export const InvoicePreviewRequest = new InvoicePreviewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoicePreviewResponse$Type extends MessageType<InvoicePreviewResponse> {
    constructor() {
        super("vlp.billing.InvoicePreviewResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "data_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<InvoicePreviewResponse>): InvoicePreviewResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.dataJson = "";
        if (value !== undefined)
            reflectionMergePartial<InvoicePreviewResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InvoicePreviewResponse): InvoicePreviewResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* string data_json */ 2:
                    message.dataJson = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InvoicePreviewResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string data_json = 2; */
        if (message.dataJson !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.dataJson);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.InvoicePreviewResponse
 */
export const InvoicePreviewResponse = new InvoicePreviewResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoiceHistoryRequest$Type extends MessageType<InvoiceHistoryRequest> {
    constructor() {
        super("vlp.billing.InvoiceHistoryRequest", [
            { no: 1, name: "from_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "to_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "account_group_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<InvoiceHistoryRequest>): InvoiceHistoryRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fromDate = "";
        message.toDate = "";
        message.accountGroupIds = [];
        if (value !== undefined)
            reflectionMergePartial<InvoiceHistoryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InvoiceHistoryRequest): InvoiceHistoryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string from_date */ 1:
                    message.fromDate = reader.string();
                    break;
                case /* string to_date */ 2:
                    message.toDate = reader.string();
                    break;
                case /* repeated int64 account_group_ids */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountGroupIds.push(reader.int64().toNumber());
                    else
                        message.accountGroupIds.push(reader.int64().toNumber());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InvoiceHistoryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string from_date = 1; */
        if (message.fromDate !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fromDate);
        /* string to_date = 2; */
        if (message.toDate !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.toDate);
        /* repeated int64 account_group_ids = 3; */
        if (message.accountGroupIds.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountGroupIds.length; i++)
                writer.int64(message.accountGroupIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.InvoiceHistoryRequest
 */
export const InvoiceHistoryRequest = new InvoiceHistoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoiceHistoryResponse$Type extends MessageType<InvoiceHistoryResponse> {
    constructor() {
        super("vlp.billing.InvoiceHistoryResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "data_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<InvoiceHistoryResponse>): InvoiceHistoryResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.dataJson = "";
        if (value !== undefined)
            reflectionMergePartial<InvoiceHistoryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InvoiceHistoryResponse): InvoiceHistoryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* string data_json */ 2:
                    message.dataJson = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InvoiceHistoryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string data_json = 2; */
        if (message.dataJson !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.dataJson);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.InvoiceHistoryResponse
 */
export const InvoiceHistoryResponse = new InvoiceHistoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ShipmentSalePriceRequest$Type extends MessageType<ShipmentSalePriceRequest> {
    constructor() {
        super("vlp.billing.ShipmentSalePriceRequest", [
            { no: 1, name: "shipment_info_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "reference_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ShipmentSalePriceRequest>): ShipmentSalePriceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shipmentInfoId = 0;
        message.referenceId = "";
        if (value !== undefined)
            reflectionMergePartial<ShipmentSalePriceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ShipmentSalePriceRequest): ShipmentSalePriceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 shipment_info_id */ 1:
                    message.shipmentInfoId = reader.int64().toNumber();
                    break;
                case /* string reference_id */ 2:
                    message.referenceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ShipmentSalePriceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 shipment_info_id = 1; */
        if (message.shipmentInfoId !== 0)
            writer.tag(1, WireType.Varint).int64(message.shipmentInfoId);
        /* string reference_id = 2; */
        if (message.referenceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.referenceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.ShipmentSalePriceRequest
 */
export const ShipmentSalePriceRequest = new ShipmentSalePriceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ShipmentSalePriceResponse$Type extends MessageType<ShipmentSalePriceResponse> {
    constructor() {
        super("vlp.billing.ShipmentSalePriceResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "data_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ShipmentSalePriceResponse>): ShipmentSalePriceResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.dataJson = "";
        if (value !== undefined)
            reflectionMergePartial<ShipmentSalePriceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ShipmentSalePriceResponse): ShipmentSalePriceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* string data_json */ 2:
                    message.dataJson = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ShipmentSalePriceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string data_json = 2; */
        if (message.dataJson !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.dataJson);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.ShipmentSalePriceResponse
 */
export const ShipmentSalePriceResponse = new ShipmentSalePriceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateTopupOrderRequest$Type extends MessageType<CreateTopupOrderRequest> {
    constructor() {
        super("vlp.billing.CreateTopupOrderRequest", [
            { no: 1, name: "wallet_info_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "provider_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "requested_amount", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "currency_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "transaction_ref", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "evidence_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "user_note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "idempotency_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateTopupOrderRequest>): CreateTopupOrderRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.walletInfoId = 0;
        message.providerCode = "";
        message.requestedAmount = "";
        message.currencyCode = "";
        message.transactionRef = "";
        message.evidenceUrl = "";
        message.userNote = "";
        message.idempotencyKey = "";
        if (value !== undefined)
            reflectionMergePartial<CreateTopupOrderRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateTopupOrderRequest): CreateTopupOrderRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 wallet_info_id */ 1:
                    message.walletInfoId = reader.int64().toNumber();
                    break;
                case /* string provider_code */ 2:
                    message.providerCode = reader.string();
                    break;
                case /* string requested_amount */ 3:
                    message.requestedAmount = reader.string();
                    break;
                case /* string currency_code */ 4:
                    message.currencyCode = reader.string();
                    break;
                case /* string transaction_ref */ 5:
                    message.transactionRef = reader.string();
                    break;
                case /* string evidence_url */ 6:
                    message.evidenceUrl = reader.string();
                    break;
                case /* string user_note */ 7:
                    message.userNote = reader.string();
                    break;
                case /* string idempotency_key */ 8:
                    message.idempotencyKey = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateTopupOrderRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 wallet_info_id = 1; */
        if (message.walletInfoId !== 0)
            writer.tag(1, WireType.Varint).int64(message.walletInfoId);
        /* string provider_code = 2; */
        if (message.providerCode !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.providerCode);
        /* string requested_amount = 3; */
        if (message.requestedAmount !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.requestedAmount);
        /* string currency_code = 4; */
        if (message.currencyCode !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.currencyCode);
        /* string transaction_ref = 5; */
        if (message.transactionRef !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.transactionRef);
        /* string evidence_url = 6; */
        if (message.evidenceUrl !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.evidenceUrl);
        /* string user_note = 7; */
        if (message.userNote !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.userNote);
        /* string idempotency_key = 8; */
        if (message.idempotencyKey !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.idempotencyKey);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.CreateTopupOrderRequest
 */
export const CreateTopupOrderRequest = new CreateTopupOrderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TopupOrderIdRequest$Type extends MessageType<TopupOrderIdRequest> {
    constructor() {
        super("vlp.billing.TopupOrderIdRequest", [
            { no: 1, name: "topup_order_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<TopupOrderIdRequest>): TopupOrderIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.topupOrderId = 0;
        if (value !== undefined)
            reflectionMergePartial<TopupOrderIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TopupOrderIdRequest): TopupOrderIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 topup_order_id */ 1:
                    message.topupOrderId = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TopupOrderIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 topup_order_id = 1; */
        if (message.topupOrderId !== 0)
            writer.tag(1, WireType.Varint).int64(message.topupOrderId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.TopupOrderIdRequest
 */
export const TopupOrderIdRequest = new TopupOrderIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelTopupOrderRequest$Type extends MessageType<CancelTopupOrderRequest> {
    constructor() {
        super("vlp.billing.CancelTopupOrderRequest", [
            { no: 1, name: "topup_order_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CancelTopupOrderRequest>): CancelTopupOrderRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.topupOrderId = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial<CancelTopupOrderRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CancelTopupOrderRequest): CancelTopupOrderRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 topup_order_id */ 1:
                    message.topupOrderId = reader.int64().toNumber();
                    break;
                case /* string reason */ 2:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CancelTopupOrderRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 topup_order_id = 1; */
        if (message.topupOrderId !== 0)
            writer.tag(1, WireType.Varint).int64(message.topupOrderId);
        /* string reason = 2; */
        if (message.reason !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.CancelTopupOrderRequest
 */
export const CancelTopupOrderRequest = new CancelTopupOrderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ApproveTopupOrderRequest$Type extends MessageType<ApproveTopupOrderRequest> {
    constructor() {
        super("vlp.billing.ApproveTopupOrderRequest", [
            { no: 1, name: "topup_order_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "admin_note", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ApproveTopupOrderRequest>): ApproveTopupOrderRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.topupOrderId = 0;
        message.adminNote = "";
        if (value !== undefined)
            reflectionMergePartial<ApproveTopupOrderRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ApproveTopupOrderRequest): ApproveTopupOrderRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 topup_order_id */ 1:
                    message.topupOrderId = reader.int64().toNumber();
                    break;
                case /* string admin_note */ 2:
                    message.adminNote = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ApproveTopupOrderRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 topup_order_id = 1; */
        if (message.topupOrderId !== 0)
            writer.tag(1, WireType.Varint).int64(message.topupOrderId);
        /* string admin_note = 2; */
        if (message.adminNote !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.adminNote);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.ApproveTopupOrderRequest
 */
export const ApproveTopupOrderRequest = new ApproveTopupOrderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RejectTopupOrderRequest$Type extends MessageType<RejectTopupOrderRequest> {
    constructor() {
        super("vlp.billing.RejectTopupOrderRequest", [
            { no: 1, name: "topup_order_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "reject_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RejectTopupOrderRequest>): RejectTopupOrderRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.topupOrderId = 0;
        message.rejectReason = "";
        if (value !== undefined)
            reflectionMergePartial<RejectTopupOrderRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RejectTopupOrderRequest): RejectTopupOrderRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 topup_order_id */ 1:
                    message.topupOrderId = reader.int64().toNumber();
                    break;
                case /* string reject_reason */ 2:
                    message.rejectReason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RejectTopupOrderRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 topup_order_id = 1; */
        if (message.topupOrderId !== 0)
            writer.tag(1, WireType.Varint).int64(message.topupOrderId);
        /* string reject_reason = 2; */
        if (message.rejectReason !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.rejectReason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.RejectTopupOrderRequest
 */
export const RejectTopupOrderRequest = new RejectTopupOrderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RefundTopupRequest$Type extends MessageType<RefundTopupRequest> {
    constructor() {
        super("vlp.billing.RefundTopupRequest", [
            { no: 1, name: "topup_order_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "amount", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RefundTopupRequest>): RefundTopupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.topupOrderId = 0;
        message.amount = "";
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial<RefundTopupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RefundTopupRequest): RefundTopupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 topup_order_id */ 1:
                    message.topupOrderId = reader.int64().toNumber();
                    break;
                case /* string amount */ 2:
                    message.amount = reader.string();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RefundTopupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 topup_order_id = 1; */
        if (message.topupOrderId !== 0)
            writer.tag(1, WireType.Varint).int64(message.topupOrderId);
        /* string amount = 2; */
        if (message.amount !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.amount);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.RefundTopupRequest
 */
export const RefundTopupRequest = new RefundTopupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTopupOrdersForReviewRequest$Type extends MessageType<GetTopupOrdersForReviewRequest> {
    constructor() {
        super("vlp.billing.GetTopupOrdersForReviewRequest", [
            { no: 1, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "provider_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "from_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "to_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "currency_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "min_amount", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "max_amount", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "keyword", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "page_query", kind: "message", T: () => BasePageQueryMsg },
            { no: 10, name: "attention_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetTopupOrdersForReviewRequest>): GetTopupOrdersForReviewRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = "";
        message.providerCode = "";
        message.fromDate = "";
        message.toDate = "";
        message.currencyCode = "";
        message.minAmount = "";
        message.maxAmount = "";
        message.keyword = "";
        message.attentionOnly = false;
        if (value !== undefined)
            reflectionMergePartial<GetTopupOrdersForReviewRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTopupOrdersForReviewRequest): GetTopupOrdersForReviewRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string status */ 1:
                    message.status = reader.string();
                    break;
                case /* string provider_code */ 2:
                    message.providerCode = reader.string();
                    break;
                case /* string from_date */ 3:
                    message.fromDate = reader.string();
                    break;
                case /* string to_date */ 4:
                    message.toDate = reader.string();
                    break;
                case /* string currency_code */ 5:
                    message.currencyCode = reader.string();
                    break;
                case /* string min_amount */ 6:
                    message.minAmount = reader.string();
                    break;
                case /* string max_amount */ 7:
                    message.maxAmount = reader.string();
                    break;
                case /* string keyword */ 8:
                    message.keyword = reader.string();
                    break;
                case /* vlp.billing.BasePageQueryMsg page_query */ 9:
                    message.pageQuery = BasePageQueryMsg.internalBinaryRead(reader, reader.uint32(), options, message.pageQuery);
                    break;
                case /* bool attention_only */ 10:
                    message.attentionOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTopupOrdersForReviewRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string status = 1; */
        if (message.status !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.status);
        /* string provider_code = 2; */
        if (message.providerCode !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.providerCode);
        /* string from_date = 3; */
        if (message.fromDate !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.fromDate);
        /* string to_date = 4; */
        if (message.toDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.toDate);
        /* string currency_code = 5; */
        if (message.currencyCode !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.currencyCode);
        /* string min_amount = 6; */
        if (message.minAmount !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.minAmount);
        /* string max_amount = 7; */
        if (message.maxAmount !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.maxAmount);
        /* string keyword = 8; */
        if (message.keyword !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.keyword);
        /* vlp.billing.BasePageQueryMsg page_query = 9; */
        if (message.pageQuery)
            BasePageQueryMsg.internalBinaryWrite(message.pageQuery, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* bool attention_only = 10; */
        if (message.attentionOnly !== false)
            writer.tag(10, WireType.Varint).bool(message.attentionOnly);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.GetTopupOrdersForReviewRequest
 */
export const GetTopupOrdersForReviewRequest = new GetTopupOrdersForReviewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TopupOrderPagedResponse$Type extends MessageType<TopupOrderPagedResponse> {
    constructor() {
        super("vlp.billing.TopupOrderPagedResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "total_records", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TopupOrderDTO },
            { no: 4, name: "attention_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "sound_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "icon_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "ring_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "reminder_minutes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "escalation_minutes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "overdue_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "attention_scope", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "reminder_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "popup_on_new", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "popup_on_login", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TopupOrderPagedResponse>): TopupOrderPagedResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.totalRecords = 0;
        message.items = [];
        message.attentionEnabled = false;
        message.soundEnabled = false;
        message.iconEnabled = false;
        message.ringCount = 0;
        message.reminderMinutes = 0;
        message.escalationMinutes = 0;
        message.overdueCount = 0;
        message.attentionScope = "";
        message.reminderKey = "";
        message.popupOnNew = false;
        message.popupOnLogin = false;
        if (value !== undefined)
            reflectionMergePartial<TopupOrderPagedResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TopupOrderPagedResponse): TopupOrderPagedResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* int32 total_records */ 2:
                    message.totalRecords = reader.int32();
                    break;
                case /* repeated vlp.billing.TopupOrderDTO items */ 3:
                    message.items.push(TopupOrderDTO.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool attention_enabled */ 4:
                    message.attentionEnabled = reader.bool();
                    break;
                case /* bool sound_enabled */ 5:
                    message.soundEnabled = reader.bool();
                    break;
                case /* bool icon_enabled */ 6:
                    message.iconEnabled = reader.bool();
                    break;
                case /* int32 ring_count */ 7:
                    message.ringCount = reader.int32();
                    break;
                case /* int32 reminder_minutes */ 8:
                    message.reminderMinutes = reader.int32();
                    break;
                case /* int32 escalation_minutes */ 9:
                    message.escalationMinutes = reader.int32();
                    break;
                case /* int32 overdue_count */ 10:
                    message.overdueCount = reader.int32();
                    break;
                case /* string attention_scope */ 11:
                    message.attentionScope = reader.string();
                    break;
                case /* string reminder_key */ 12:
                    message.reminderKey = reader.string();
                    break;
                case /* bool popup_on_new */ 13:
                    message.popupOnNew = reader.bool();
                    break;
                case /* bool popup_on_login */ 14:
                    message.popupOnLogin = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TopupOrderPagedResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_records = 2; */
        if (message.totalRecords !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalRecords);
        /* repeated vlp.billing.TopupOrderDTO items = 3; */
        for (let i = 0; i < message.items.length; i++)
            TopupOrderDTO.internalBinaryWrite(message.items[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool attention_enabled = 4; */
        if (message.attentionEnabled !== false)
            writer.tag(4, WireType.Varint).bool(message.attentionEnabled);
        /* bool sound_enabled = 5; */
        if (message.soundEnabled !== false)
            writer.tag(5, WireType.Varint).bool(message.soundEnabled);
        /* bool icon_enabled = 6; */
        if (message.iconEnabled !== false)
            writer.tag(6, WireType.Varint).bool(message.iconEnabled);
        /* int32 ring_count = 7; */
        if (message.ringCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.ringCount);
        /* int32 reminder_minutes = 8; */
        if (message.reminderMinutes !== 0)
            writer.tag(8, WireType.Varint).int32(message.reminderMinutes);
        /* int32 escalation_minutes = 9; */
        if (message.escalationMinutes !== 0)
            writer.tag(9, WireType.Varint).int32(message.escalationMinutes);
        /* int32 overdue_count = 10; */
        if (message.overdueCount !== 0)
            writer.tag(10, WireType.Varint).int32(message.overdueCount);
        /* string attention_scope = 11; */
        if (message.attentionScope !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.attentionScope);
        /* string reminder_key = 12; */
        if (message.reminderKey !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.reminderKey);
        /* bool popup_on_new = 13; */
        if (message.popupOnNew !== false)
            writer.tag(13, WireType.Varint).bool(message.popupOnNew);
        /* bool popup_on_login = 14; */
        if (message.popupOnLogin !== false)
            writer.tag(14, WireType.Varint).bool(message.popupOnLogin);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.billing.TopupOrderPagedResponse
 */
export const TopupOrderPagedResponse = new TopupOrderPagedResponse$Type();
